
      if (window.DESCOPE_NONCE) {
        __webpack_require__.nc = window.DESCOPE_NONCE;
        window.__webpack_nonce__ = window.DESCOPE_NONCE;
      }
    